import React, { useEffect, useState } from 'react'
import ServiceCard from '../components/ServiceCard'
import { getServices } from "../middleware/servicesFetch";

const Services = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    getServices()
      .then(setServices)
      .catch(() => setServices([]));
  }, []);
  return (
    <div style={{"backgroundColor": "#e8f5e9"}}>
      <div id="services" className='container py-5'>
        <div className="text-center mb-5">
          <h1 className="text-primary fw-bold display-4 mb-3">Our Services</h1>
          <div className="border-bottom fw-bold border-primary mx-auto" style={{ width: '100%' }}></div>
        </div>
        <div className="row justify-content-center my-3">
          {services.map((service) => (
            <div key={service.id} className="col-md-6 col-lg-4 mb-4 d-flex justify-content-center">
              <ServiceCard data={service} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;